import React, { useEffect, useState } from 'react';
import './MediaKit.css';

// Creators' social reach and recent content now comes from their July media
// kit (set by a super-admin) instead of Meta/TikTok OAuth.

const PLATFORM_PATHS = {
  instagram: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  tiktok: 'M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z',
  youtube: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  facebook: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  x: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  snapchat: 'M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.076-.375-.09-.84-.181-1.455-.181-.439 0-.9.061-1.365.181-.629.165-1.185.571-1.74.975-.811.585-1.65 1.191-3.024 1.191h-.06c-1.374 0-2.213-.606-3.024-1.191-.554-.404-1.11-.81-1.739-.975-.464-.119-.93-.181-1.364-.181-.66 0-1.11.104-1.456.181-.225.044-.405.076-.539.076-.24 0-.449-.12-.539-.39a2.7 2.7 0 0 1-.135-.554 8.82 8.82 0 0 0-.164-.569c-1.874-.284-2.906-.702-3.146-1.271a.506.506 0 0 1-.044-.225c-.016-.24.164-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809a3.72 3.72 0 0 1-.346-.12c-.823-.329-1.227-.719-1.212-1.168 0-.36.284-.689.734-.838a1.14 1.14 0 0 1 .51-.09c.119 0 .3.015.449.104.374.18.735.301 1.035.301.196 0 .314-.045.375-.075a8.52 8.52 0 0 1-.033-.57c-.104-1.628-.229-3.654.3-4.848C7.853 1.069 11.216.793 12.206.793z',
};
PLATFORM_PATHS.twitter = PLATFORM_PATHS.x;

export function PlatformIcon({ platform, size = 16 }) {
  const path = PLATFORM_PATHS[platform];
  if (!path) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d={path}/>
    </svg>
  );
}

function VerifiedTick() {
  return (
    <svg className="mk-verified" width="14" height="14" viewBox="0 0 24 24" aria-label="Verified">
      <circle cx="12" cy="12" r="11" fill="currentColor"/>
      <path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

// 3717883 -> 3.7M, 617571 -> 617K, 18617 -> 18.6K. Truncates so reach is never overstated.
export const formatCount = (num) => {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return '—';
  const n = Number(num);
  const scaled = (value, suffix) => {
    const digits = value >= 100 ? 0 : 1;
    const factor = 10 ** digits;
    return `${(Math.floor(value * factor) / factor).toFixed(digits).replace(/\.0$/, '')}${suffix}`;
  };
  if (n >= 1e9) return scaled(n / 1e9, 'B');
  if (n >= 1e6) return scaled(n / 1e6, 'M');
  if (n >= 1e3) return scaled(n / 1e3, 'K');
  return String(Math.round(n));
};

export const formatPercent = (num) =>
  num === null || num === undefined ? '—' : `${Number(num).toFixed(1).replace(/\.0$/, '')}%`;

const syncedAgo = (iso) => {
  if (!iso) return '';
  const min = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  if (min < 1440) return `${Math.floor(min / 60)}h ago`;
  const days = Math.floor(min / 1440);
  return days === 1 ? 'yesterday' : `${days}d ago`;
};

const shortUrl = (url) => (url || '').replace(/^https?:\/\/(www\.)?/, '');

function PostTile({ post, onBroken }) {
  const count = post.viewCount ?? post.likeCount;
  return (
    <a
      href={post.postUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="mk-tile"
      title={`View on ${post.platform}`}
    >
      <img src={post.thumbnailUrl} alt="" loading="lazy" onError={onBroken} />
      <span className={`mk-tile-badge ${post.platform}`}>
        <PlatformIcon platform={post.platform} size={11} />
      </span>
      {count !== null && count !== undefined && (
        <span className="mk-tile-stat">
          {post.isVideo && post.viewCount != null ? '▶' : '♥'} {formatCount(count)}
        </span>
      )}
    </a>
  );
}

// Full-screen view of the creator's July page, with a new-tab fallback.
function MediaKitViewer({ mediaKit, onClose }) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="mk-viewer" onClick={onClose}>
      <div className="mk-viewer-frame" onClick={(e) => e.stopPropagation()}>
        <div className="mk-viewer-bar">
          <span className="mk-viewer-title">
            {mediaKit.name || 'Media kit'}
            <span>{shortUrl(mediaKit.url)}</span>
          </span>
          <a href={mediaKit.url} target="_blank" rel="noopener noreferrer" className="mk-viewer-open">
            Open in new tab ↗
          </a>
          <button type="button" className="mk-viewer-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="mk-viewer-body">
          {/* Stays underneath: July paints its own background once it has rendered */}
          <div className="mk-viewer-loading">
            <span className="mk-sync-spinner" />
            Loading media kit…
          </div>
          <iframe
            src={mediaKit.url}
            title={`${mediaKit.name || 'Creator'} media kit`}
            className={loaded ? 'loaded' : ''}
            onLoad={() => setLoaded(true)}
          />
        </div>
      </div>
    </div>
  );
}

// Full media kit for profile views. `emptyText` depends on who is looking.
export function MediaKit({ mediaKit, emptyText = 'No media kit has been added yet.' }) {
  const [tab, setTab] = useState('all');
  const [broken, setBroken] = useState({});
  const [viewing, setViewing] = useState(false);

  if (!mediaKit) {
    return (
      <div className="mk-empty">
        <span className="mk-empty-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            <rect x="3" y="3" width="7" height="9" rx="1.5"/>
            <rect x="14" y="3" width="7" height="5" rx="1.5"/>
            <rect x="14" y="12" width="7" height="9" rx="1.5"/>
            <rect x="3" y="16" width="7" height="5" rx="1.5"/>
          </svg>
        </span>
        <p>{emptyText}</p>
      </div>
    );
  }

  if (!mediaKit.ready) {
    return (
      <div className="mk-empty syncing">
        <span className="mk-sync-spinner" />
        <p>
          <strong>Media kit is syncing</strong>
          {mediaKit.syncError || 'Stats and recent content will appear here shortly.'}
        </p>
        {mediaKit.url && (
          <a href={mediaKit.url} target="_blank" rel="noopener noreferrer" className="mk-link">
            {shortUrl(mediaKit.url)} ↗
          </a>
        )}
      </div>
    );
  }

  const platforms = mediaKit.platforms || [];
  const tabs = platforms.filter((p) => p.posts?.length);
  const activePlatform = platforms.find((p) => p.platform === tab);
  const posts = (activePlatform ? activePlatform.posts : mediaKit.recentPosts || [])
    .filter((p) => p.thumbnailUrl && p.postUrl && !broken[p.thumbnailUrl]);
  const total = mediaKit.totalFollowers || 0;

  return (
    <div className="mk">
      <div className="mk-hero">
        <div className="mk-reach">
          <span className="mk-eyebrow">Total reach</span>
          <span className="mk-reach-value">{formatCount(mediaKit.totalFollowers)}</span>
          <span className="mk-reach-sub">
            across {platforms.length} platform{platforms.length === 1 ? '' : 's'}
          </span>
        </div>
        <span className="mk-live">
          <span className="mk-live-dot" />
          Live from July{mediaKit.syncedAt && ` · updated ${syncedAgo(mediaKit.syncedAt)}`}
        </span>
        {total > 0 && platforms.length > 1 && (
          <div className="mk-share" aria-hidden="true">
            {platforms.map((p) => (
              <span
                key={p.platform}
                style={{ flexGrow: p.followers || 0 }}
                title={`${p.label}: ${formatCount(p.followers)}`}
              />
            ))}
          </div>
        )}
      </div>

      {platforms.length > 0 && (
        <ul className="mk-platforms">
          {platforms.map((p) => (
            <li key={p.platform} className="mk-platform">
              <span className={`mk-platform-icon ${p.platform}`}>
                <PlatformIcon platform={p.platform} size={18} />
              </span>
              <span className="mk-platform-name">
                <span className="mk-platform-label">
                  {p.label}
                  {p.isVerified && <VerifiedTick />}
                </span>
                {p.username && (
                  p.accountUrl ? (
                    <a href={p.accountUrl} target="_blank" rel="noopener noreferrer">@{p.username}</a>
                  ) : (
                    <span>@{p.username}</span>
                  )
                )}
              </span>
              <span className="mk-metric">
                <strong>{formatCount(p.followers)}</strong>
                <span>followers</span>
              </span>
              <span className="mk-metric">
                <strong>{formatPercent(p.engagementRate)}</strong>
                <span className="mk-label-long">engagement</span>
                <span className="mk-label-short">eng.</span>
              </span>
              {p.avgViews != null && (
                <span className="mk-metric optional">
                  <strong>{formatCount(p.avgViews)}</strong>
                  <span>avg. views</span>
                </span>
              )}
            </li>
          ))}
        </ul>
      )}

      {(mediaKit.recentPosts?.length > 0 || tabs.length > 0) && (
        <div className="mk-content">
          <div className="mk-content-head">
            <h4>Recent content</h4>
            {tabs.length > 1 && (
              <div className="mk-tabs" role="tablist">
                {[{ platform: 'all', label: 'All' }, ...tabs].map((p) => (
                  <button
                    key={p.platform}
                    type="button"
                    role="tab"
                    aria-selected={tab === p.platform}
                    className={tab === p.platform ? 'active' : ''}
                    onClick={() => setTab(p.platform)}
                  >
                    {p.platform !== 'all' && <PlatformIcon platform={p.platform} size={12} />}
                    {p.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          {posts.length > 0 ? (
            <div className="mk-grid">
              {posts.map((post) => (
                <PostTile
                  key={post.postUrl}
                  post={post}
                  onBroken={() => setBroken((prev) => ({ ...prev, [post.thumbnailUrl]: true }))}
                />
              ))}
            </div>
          ) : (
            <p className="mk-muted">No recent posts to show.</p>
          )}
        </div>
      )}

      <div className="mk-footer">
        <span className="mk-muted">{shortUrl(mediaKit.url)}</span>
        <div className="mk-footer-actions">
          <a href={mediaKit.url} target="_blank" rel="noopener noreferrer" className="mk-link">
            Open in new tab ↗
          </a>
          <button type="button" className="mk-view-btn" onClick={() => setViewing(true)}>
            View full media kit
          </button>
        </div>
      </div>

      {viewing && <MediaKitViewer mediaKit={mediaKit} onClose={() => setViewing(false)} />}
    </div>
  );
}

// Compact version for creator cards and admin lists: platform chips and three
// recent thumbnails. With `identity`, also shows who the July page belongs to.
export function MediaKitSummary({ mediaKit, identity = false }) {
  const [broken, setBroken] = useState({});
  if (!mediaKit) return null;

  const platforms = mediaKit.platforms || [];
  const thumbs = (mediaKit.recentPosts || [])
    .filter((p) => p.thumbnailUrl && !broken[p.thumbnailUrl])
    .slice(0, 3);

  return (
    <div className="mk-summary">
      {identity && (
        <a href={mediaKit.url} target="_blank" rel="noopener noreferrer" className="mk-identity">
          {mediaKit.headshotUrl ? (
            <img src={mediaKit.headshotUrl} alt="" />
          ) : (
            <span className="mk-identity-fallback">{(mediaKit.name || '?').charAt(0)}</span>
          )}
          <span className="mk-identity-text">
            <strong>{mediaKit.name || mediaKit.username || 'July media kit'}</strong>
            <span>
              {[mediaKit.location, shortUrl(mediaKit.url)].filter(Boolean).join(' · ')} ↗
            </span>
          </span>
          {mediaKit.totalFollowers != null && (
            <span className="mk-identity-reach">
              <strong>{formatCount(mediaKit.totalFollowers)}</strong>
              <span>reach</span>
            </span>
          )}
        </a>
      )}
      {mediaKit.ready === false ? (
        <p className="mk-muted small">Syncing from July{mediaKit.syncError ? ` — ${mediaKit.syncError}` : '…'}</p>
      ) : (
        <div className="mk-summary-row">
          <div className="mk-chips">
            {platforms.map((p) => (
              <span key={p.platform} className="mk-chip" title={`${p.label}${p.username ? ` @${p.username}` : ''}`}>
                <PlatformIcon platform={p.platform} size={12} />
                {formatCount(p.followers)}
              </span>
            ))}
          </div>
          {thumbs.length > 0 && (
            <div className="mk-thumbs">
              {thumbs.map((post) => (
                <a
                  key={post.postUrl || post.thumbnailUrl}
                  href={post.postUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={post.thumbnailUrl}
                    alt=""
                    loading="lazy"
                    onError={() => setBroken((prev) => ({ ...prev, [post.thumbnailUrl]: true }))}
                  />
                </a>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MediaKit;
